module.exports = __webpack_public_path__ + "static/media/logo-dark.d565eaad.svg";